(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rijoux-product-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rijoux-photo-piece')) {
  customElements.define('rijoux-photo-piece', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const stage = this.querySelector('[data-stage]');
      const photo = this.querySelector('[data-main]');
      const label = this.querySelector('[data-view-label]');
      const dialog = this.querySelector('dialog');
      const large = this.querySelector('[data-dialog-image]');
      const views = Array.from(this.querySelectorAll('[data-source]'));
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      views.forEach(button => button.addEventListener('click', () => {
        views.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        photo.src = button.dataset.source;
        large.src = button.dataset.source;
        stage.dataset.view = button.dataset.kind;
        label.textContent = button.dataset.label;
        this.querySelector('[data-dialog-label]').textContent = button.dataset.label;
        stage.style.setProperty('--rx', '0deg');
        stage.style.setProperty('--ry', '0deg');
      }, {signal}));
      this.querySelector('.rjp-views').dataset.ready = 'true';
      this.querySelector('[data-open]').addEventListener('click', () => dialog.showModal(), {signal});
      this.querySelector('[data-close]').addEventListener('click', () => dialog.close(), {signal});
      dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } }, {signal});
      stage.addEventListener('pointermove', event => {
        if (reduce.matches || event.pointerType !== 'mouse' || stage.dataset.view === 'original') return;
        const box = stage.getBoundingClientRect();
        stage.style.setProperty('--rx', ((event.clientY - box.top) / box.height * -5 + 2.5) + 'deg');
        stage.style.setProperty('--ry', ((event.clientX - box.left) / box.width * 7 - 3.5) + 'deg');
      }, {signal});
      stage.addEventListener('pointerleave', () => { stage.style.setProperty('--rx', '0deg'); stage.style.setProperty('--ry', '0deg'); }, {signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rijoux-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rijoux-facet')) {
  class RijouxFacet extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const canvas = this.querySelector('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const slider = this.querySelector('[data-rotation]');
      const output = this.querySelector('[data-angle]');
      const motion = this.querySelector('[data-motion]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = reduced.matches, visible = false, angle = .61, tone = 'warm', cut = 'brilliant';
      let w = 600, h = 440, last = 0, lastUi = 0, pointer = null, mesh;
      const norm = v => {const n = Math.hypot(...v) || 1; return v.map(x => x / n);};
      const dot = (a,b) => a.reduce((s,v,i) => s + v * b[i],0);
      const build = kind => {
        const vertices = [], faces = [];
        const ring = (count,radius,y,phase=0) => Array.from({length:count},(_,i) => {
          const a=i*Math.PI*2/count+phase;vertices.push([Math.cos(a)*radius,y,Math.sin(a)*radius]);return vertices.length-1;
        });
        if (kind === 'brilliant') {
          const top=ring(12,.51,-.63), edge=ring(24,1.04,-.23), base=ring(24,1.04,-.15), lower=ring(12,.53,.52,Math.PI/12);
          faces.push(top);
          for(let i=0;i<12;i++) {
            const j=(i+1)%12,a=i*2,b=(a+1)%24,c=(a+2)%24;
            faces.push([top[i],top[j],edge[b]],[top[i],edge[a],edge[b]],[top[j],edge[b],edge[c]]);
            faces.push([base[a],base[b],lower[i]],[base[b],base[c],lower[i]],[base[c],lower[j],lower[i]]);
          }
          for(let i=0;i<24;i++)faces.push([edge[i],edge[(i+1)%24],base[(i+1)%24],base[i]]);
          const tip=vertices.push([0,1.07,0])-1;
          for(let i=0;i<12;i++)faces.push([lower[i],lower[(i+1)%12],tip]);
        } else {
          const outline=[[-.64,-1],[.64,-1],[1,-.64],[1,.64],[.64,1],[-.64,1],[-1,.64],[-1,-.64]];
          const rings=[[.52,-.58],[.72,-.45],[.88,-.31],[1,-.17],[1,-.10],[.80,.19],[.56,.46],[.25,.70]];
          for(const [radius,y] of rings)for(const [x,z] of outline)vertices.push([x*radius*1.15,y,z*radius*.76]);
          faces.push(Array.from({length:8},(_,i)=>i));
          for(let r=0;r<rings.length-1;r++)for(let i=0;i<8;i++)faces.push([r*8+i,r*8+(i+1)%8,(r+1)*8+(i+1)%8,(r+1)*8+i]);
          faces.push(Array.from({length:8},(_,i)=>56+i));
        }
        return {vertices,faces:faces.map(ids=>{
          const a=vertices[ids[0]],b=vertices[ids[1]],c=vertices[ids[2]],u=b.map((v,i)=>v-a[i]),v=c.map((n,i)=>n-a[i]);
          let normal=norm([u[1]*v[2]-u[2]*v[1],u[2]*v[0]-u[0]*v[2],u[0]*v[1]-u[1]*v[0]]);
          const center=[0,1,2].map(i=>ids.reduce((s,j)=>s+vertices[j][i],0)/ids.length);
          if(dot(normal,center)<0)normal=normal.map(n=>-n);
          return {ids,normal,center};
        })};
      };
      mesh=build(cut);
      const key=norm([-.65,-.85,-1]),fill=norm([.8,-.1,-.8]),half=norm([-.3,-.5,-1]),rim=norm([.9,.1,.2]);
      const draw = () => {
        if(!w||!h)return;
        ctx.clearRect(0,0,w,h);
        const ca=Math.cos(angle),sa=Math.sin(angle),cx=Math.cos(-.34),sx=Math.sin(-.34),cz=Math.cos(-.12),sz=Math.sin(-.12);
        const rotate=([x,y,z])=>{const a=x*ca+z*sa,b=-x*sa+z*ca,c=y*cx-b*sx,d=y*sx+b*cx;return[a*cz-c*sz,a*sz+c*cz,d];};
        const scale=Math.min(w*.35,h*.38),floor=h*.86;
        const project=([x,y,z])=>{const f=4.6/(4.6+z*.50);return[w*.5+x*scale*f,h*.40+y*scale*f];};
        ctx.save();ctx.translate(w*.5,floor);ctx.scale(1,.10);
        const shadow=ctx.createRadialGradient(0,0,0,0,0,scale);shadow.addColorStop(0,'rgba(0,0,0,.7)');shadow.addColorStop(1,'rgba(0,0,0,0)');
        ctx.fillStyle=shadow;ctx.beginPath();ctx.arc(0,0,scale,0,Math.PI*2);ctx.fill();
        const halo=ctx.createRadialGradient(0,0,scale*.2,0,0,scale*.82);halo.addColorStop(0,'rgba(255,255,255,0)');halo.addColorStop(.6,tone==='warm'?'rgba(239,251,4,.13)':'rgba(255,255,255,.1)');halo.addColorStop(1,'rgba(255,255,255,0)');
        ctx.fillStyle=halo;ctx.beginPath();ctx.arc(0,0,scale*.85,0,Math.PI*2);ctx.fill();ctx.restore();
        const points=mesh.vertices.map(rotate),screen=points.map(project);
        const faces=mesh.faces.map(face=>({...face,n:rotate(face.normal),center:rotate(face.center)})).filter(f=>f.n[2]<.02).sort((a,b)=>b.center[2]-a.center[2]);
        for(const face of faces) {
          const {n,ids}=face;
          const diffuse=Math.max(0,dot(n,key)),soft=Math.max(0,dot(n,fill)),spec=Math.pow(Math.max(0,dot(n,half)),38);
          const rx=-2*n[2]*n[0],ry=-2*n[2]*n[1],rz=-1+2*n[2]*n[2];
          const panel=Math.exp(-Math.pow((rx+.38)/.24,2))*Math.exp(-Math.pow((ry+.08)/1.1,2));
          const strip=Math.exp(-Math.pow((rx-.64)/.07,2))*.72;
          const inner=Math.pow(Math.max(0,-rz),3)*.25;
          const neon=tone==='warm'?Math.pow(Math.max(0,dot(n,rim)),3):0;
          const lum=Math.min(96,10+diffuse*30+soft*8+panel*55+strip*38+spec*45+inner*30);
          const coords=ids.map(i=>screen[i]);
          ctx.beginPath();coords.forEach(([x,y],i)=>i?ctx.lineTo(x,y):ctx.moveTo(x,y));ctx.closePath();
          const grad=ctx.createLinearGradient(coords[0][0],coords[0][1],coords[0][0]+scale*.6,coords[0][1]+scale);
          const sat=Math.min(76,neon*100),hue=tone==='warm'?63:0;
          grad.addColorStop(0,`hsl(${hue} ${sat}% ${Math.min(98,lum+10)}%)`);grad.addColorStop(.55,`hsl(${hue} ${sat*.7}% ${lum}%)`);grad.addColorStop(1,`hsl(${hue} ${sat}% ${Math.max(6,lum-12)}%)`);
          ctx.fillStyle=grad;ctx.fill();
          ctx.strokeStyle=`rgba(255,255,255,${.08+Math.max(0,diffuse-.6)*.45})`;ctx.lineWidth=.6;ctx.stroke();
          if(spec>.64 && lum>78){const center=project(face.center),s=2+spec*5;ctx.strokeStyle=`rgba(255,255,255,${spec*.65})`;ctx.lineWidth=.7;ctx.beginPath();ctx.moveTo(center[0]-s,center[1]);ctx.lineTo(center[0]+s,center[1]);ctx.moveTo(center[0],center[1]-s);ctx.lineTo(center[0],center[1]+s);ctx.stroke();}
        }
      };
      const buttonState=()=>{motion.textContent=paused?this.dataset.play:this.dataset.pause;this.dataset.motion=paused?'paused':'playing';};
      const angleState=()=>{const degrees=Math.round(((angle*180/Math.PI)%360+360)%360)%360;slider.value=String(degrees);output.textContent=degrees+'°';};
      const stop=()=>{cancelAnimationFrame(this.frame);this.frame=0;last=0;};
      const tick=now=>{
        if(!visible||document.hidden||paused||pointer){stop();return;}
        if(!last)last=now;
        if(now-last>=32){angle=(angle+Math.min(now-last,80)*.00013)%(Math.PI*2);last=now;draw();if(now-lastUi>300){angleState();lastUi=now;}}
        this.frame=requestAnimationFrame(tick);
      };
      const start=()=>{if(!this.frame&&visible&&!document.hidden&&!paused&&!pointer)this.frame=requestAnimationFrame(tick);};
      const pause=()=>{paused=true;stop();angleState();buttonState();};
      const resize=()=>{
        const box=canvas.getBoundingClientRect();if(!box.width||!box.height)return;
        w=box.width;h=box.height;
        const ratio=Math.min(devicePixelRatio||1,w<500?1.5:2),cw=Math.round(w*ratio),ch=Math.round(h*ratio);
        if(canvas.width!==cw||canvas.height!==ch){canvas.width=cw;canvas.height=ch;ctx.setTransform(ratio,0,0,ratio,0,0);}
        draw();
      };
      slider.addEventListener('focus',pause,{signal});
      slider.addEventListener('input',()=>{const degrees=Number(slider.value);pause();angle=degrees*Math.PI/180;angleState();draw();},{signal});
      motion.addEventListener('click',()=>{paused=!paused;angleState();buttonState();paused?stop():start();},{signal});
      this.querySelectorAll('[data-tone]').forEach(button=>button.addEventListener('click',()=>{
        tone=button.dataset.tone;this.querySelectorAll('[data-tone]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));draw();
      },{signal}));
      this.querySelectorAll('[data-cut]').forEach(button=>button.addEventListener('click',()=>{
        cut=button.dataset.cut;mesh=build(cut);this.querySelectorAll('[data-cut]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.querySelector('[data-study-name]').textContent=button.dataset.label;this.dataset.cut=cut;angle=.61;angleState();draw();
      },{signal}));
      canvas.addEventListener('pointerdown',event=>{if(event.button!==0)return;pause();pointer={id:event.pointerId,x:event.clientX,y:event.clientY,angle};canvas.setPointerCapture(event.pointerId);},{signal});
      canvas.addEventListener('pointermove',event=>{if(!pointer||pointer.id!==event.pointerId)return;const dx=event.clientX-pointer.x;if(Math.abs(dx)>Math.abs(event.clientY-pointer.y)){angle=pointer.angle+dx*.012;angleState();draw();}},{signal});
      const release=()=>{pointer=null;};
      canvas.addEventListener('pointerup',release,{signal});canvas.addEventListener('pointercancel',release,{signal});canvas.addEventListener('lostpointercapture',release,{signal});
      document.addEventListener('visibilitychange',()=>document.hidden?stop():start(),{signal});
      reduced.addEventListener('change',()=>{if(reduced.matches)pause();},{signal});
      this.observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;visible?start():stop();},{threshold:.05});this.observer.observe(this);
      this.resizer=new ResizeObserver(resize);this.resizer.observe(canvas);
      this.querySelector('.rjx-art-controls').hidden=false;this.dataset.ready='true';this.dataset.cut=cut;buttonState();angleState();resize();
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;cancelAnimationFrame(this.frame);this.frame=0;this.observer?.disconnect();this.resizer?.disconnect();}
  }
  customElements.define('rijoux-facet',RijouxFacet);
}

  } catch(e) { console.error(e); }
})();
})();
